import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { PrismicProvider } from "@prismicio/react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { client } from "./prismic";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <PrismicProvider client={client}>
      <App />
    </PrismicProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
